import { Box, Fade, Tooltip, Typography } from '@mui/material'
import theme from 'lib/theme'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { PickingStatus, Product } from 'types/model/product'
import { ProductNoteStyling, ReplaceColWrapper } from './OrderProduct.styled'

export const ReplaceColumn = ({ product }: { product: Product }) => {
  const { t } = useTranslation()
  if (product.productType) return <Box />
  return (
    <Box>
      <ReplaceColWrapper>
        <div style={{ overflowY: 'scroll', height: theme.spacing(9) }}>
          {product.allowReplace ? (
            <Typography>{t('orderProduct.allowed')}</Typography>
          ) : (
            <Typography>{t('orderProduct.notAllowed')}</Typography>
          )}
          {product.notes.length > 0 && (
            <Tooltip
              TransitionComponent={Fade}
              title={
                <Typography
                  variant='body1'
                  sx={{ margin: '4px', color: theme.palette.text.primary }}>
                  {product.notes[0]}
                </Typography>
              }
              componentsProps={{
                tooltip: {
                  sx: ProductNoteStyling,
                },
              }}>
              <Typography
                variant='body2'
                sx={{
                  color: theme.palette.text.secondary,
                  '&:hover': { cursor: 'pointer' },
                }}>
                {t('orderProduct.shopperNote')}
              </Typography>
            </Tooltip>
          )}
        </div>
      </ReplaceColWrapper>
      {product.pickingStatus.toLowerCase() === PickingStatus.SUBSTITUTED && (
        <Box
          sx={{
            height: theme.spacing(9),
          }}
        />
      )}
    </Box>
  )
}
